export enum CommissionStatusColor {
  PN = '5CB85C',
  PR = 'AFAFAF',
  ON = 'D9534F',
  VO = '5BC0DE',
}
